<script>
export default {
    name: "OPDiagnosisReport",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchOPDiagnosisReport(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

       fetchOPDiagnosisReport() {
           
            let url = `PatientReports/GetOutPatientDiagnosis?Datefrom=${this.$route.query.dateFrom}&Dateto=${this.$route.query.dateTo}`;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}` : ``;
            url += this.$route.query.treatedBy ? `&TreatedBy=${this.$route.query.treatedBy}` : ``;
            return this.$http.get(url).then(response => {
                this.patients = response.data.patientDiagnosisReport;
            }).catch(() => {});
        }, 
    }
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full my-2 text-center">
            <h5 class="font-medium">OP Diagnosis Report</h5>
        </div>
        <table class="table table-striped">
            <thead class="text-sm">
                  <tr class="w-full flex">
                      <th class="p-tiny w-1/6">Names</th>
                      <th class="p-tiny w-1/12">VisitNo</th>
                      <th class="p-tiny w-1/12">Date</th>
                      <th class="p-tiny w-1/12">IP NO</th>
                      <th class="p-tiny w-1/12">OP No</th>
                      <th class="p-tiny w-1/6">Gen Examination</th>
                      <th class="p-tiny w-1/6">Diagnosis</th>
                      <th class="p-tiny w-1/6">Username</th>
                  </tr>
            </thead>
            <tbody class="text-xs flex flex-col items-center">
                <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                    <td class="p-tiny w-1/6">{{ patient.names }}</td>
                    <td class="p-tiny w-1/12">{{ patient.visitNo }}</td>
                    <td class="p-tiny w-1/12">{{ patient.trxDate | dateFormat }}</td>
                    <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                    <td class="p-tiny w-1/12">{{ patient.opfileno }}</td>
                    <td class="p-tiny w-1/6">{{ patient.generalExamination }}</td>
                    <td class="p-tiny w-1/6">{{ patient.diagnosis }}</td>
                    <td class="p-tiny w-1/6">{{ patient.userName }}</td>
                </tr>
                <tr class="w-full flex">
                    <th class="p-tiny w-1/2"></th>
                    <th class="p-tiny w-1/2 text-right">Diagnosis Recorded: {{ patients.length }}</th>
                </tr>
            </tbody>
        </table>
    </div>
</template>